<template>
  <UiAdditionalInformation path="/tilleggsopplysninger/nyhetsbrev">
    <UiCommonsHubspot title="Meld deg på" />
  </UiAdditionalInformation>
</template>
